import { DIAMOND_SHAPE_LIST } from '../constants/appConstants';

const SHAPE_NAME_RE = /^[A-Z0-9][A-Z0-9 ]{0,19}$/;

export function normalizeShapeName(raw) {
  if (raw == null) return '';
  return String(raw).trim().toUpperCase();
}

export function isValidShapeNameFormat(name) {
  const upper = normalizeShapeName(name);
  return upper.length > 0 && upper.length <= 20 && SHAPE_NAME_RE.test(upper);
}

export function mapCompanyCustomShapes(data) {
  return Array.isArray(data?.customShapes)
    ? data.customShapes.map((entry) => ({
      _id: String(entry._id),
      name: normalizeShapeName(entry.name),
    }))
    : [];
}

export function createEmptyCustomShape() {
  return {
    _id: `new-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    name: '',
  };
}

export function buildCustomShapesSavePayload(shapes) {
  return {
    customShapes: (shapes || []).map((shape) => ({
      ...(shape._id && !String(shape._id).startsWith('new-') ? { _id: shape._id } : {}),
      name: normalizeShapeName(shape.name),
    })),
  };
}

export function validateCustomShapesForm(shapes, t) {
  const canonicalLower = new Set(DIAMOND_SHAPE_LIST.map((s) => s.toLowerCase()));
  const names = new Set();
  for (const shape of shapes || []) {
    const name = normalizeShapeName(shape.name);
    if (!name) {
      return t('settings.shapes.nameRequired');
    }
    if (!isValidShapeNameFormat(name)) {
      return t('settings.shapes.invalidFormat');
    }
    const lower = name.toLowerCase();
    if (canonicalLower.has(lower)) {
      return t('settings.shapes.standardShape', { name });
    }
    if (names.has(lower)) {
      return t('settings.shapes.duplicateName');
    }
    names.add(lower);
  }
  return '';
}

/** Merge canonical + company session list + inventory distinct shapes. */
export function mergeShapeOptionSources(inventoryShapes, companyCustomShapes) {
  const fromCompany = (Array.isArray(companyCustomShapes) ? companyCustomShapes : [])
    .map((entry) => (typeof entry === 'string' ? entry : entry?.name))
    .filter(Boolean);
  const fromApi = Array.isArray(inventoryShapes) ? inventoryShapes : [];
  const merged = [...DIAMOND_SHAPE_LIST, ...fromCompany, ...fromApi]
    .filter(Boolean)
    .map((s) => normalizeShapeName(s));
  return [...new Set(merged)].sort();
}
